/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Goals_LeadInputs */

const en_for_whom_goals_lead = /** @type {(inputs: For_Whom_Goals_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whatever you come for,`)
};

const pl_for_whom_goals_lead = /** @type {(inputs: For_Whom_Goals_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z czym przychodzisz,`)
};

/**
* | output |
* | --- |
* | "Whatever you come for," |
*
* @param {For_Whom_Goals_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_goals_lead = /** @type {((inputs?: For_Whom_Goals_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Goals_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_goals_lead(inputs)
	return en_for_whom_goals_lead(inputs)
});